import * as React from "react";
import { useComponentsContext } from "./internal/provider.js";
export default function HelpPanelManaged(props) {
    const components = useComponentsContext();
    return (components === null || components === void 0 ? void 0 : components.Drawer) ? React.createElement(components.Drawer, { ...props }) : null;
}
